
import { Component, Mixins } from "vue-property-decorator";
import AuthenticateMixin from "../../common/mixins/auth.mixin";
import EmployeeDetails from "@/common/components/employee/employee-details.vue";
import ConfirmDialog from "@/common/components/confirm-modal.vue";
import RatingTable from "./rating-table.vue";
import { RatingDataDto, RatingFormDto } from "@/types/rating.type";
import { RatingStatus } from "@/common/constants";
import { mapState } from "vuex";

@Component({
  components: {
    RatingTable,
    EmployeeDetails,
    ConfirmDialog
  },
  computed: {
    ...mapState("Ratings", ["ratingData"])
  }
})
class RatingsComponent extends Mixins(AuthenticateMixin) {
  ratingData!: RatingDataDto | null;

  loading = true;
  confirmModalShow = false;
  form: RatingFormDto | null = null;
  currentEmployee : { userId: number, practiceId: number } | null = null;
  isEmployeeDetailsVisible = false;
      
  showDetails(employeeId: number): void {
    this.currentEmployee = { userId: employeeId, practiceId: this.userInfo()?.practiceId ?? 0 };
    this.isEmployeeDetailsVisible = true;
  }

  showWarning(isChecked: boolean): void {
    if (isChecked) {
      this.confirmModalShow = true;
    }
  }

  async mounted(): Promise<void> {
    await this.fetchData();
  }

  async fetchData(): Promise<void> {
    this.loading = true;

    await this.$store.dispatch("Ratings/getData");
    await this.$store.dispatch("Ratings/getRatingsByOffice", this.userInfo()?.practiceId);

    this.loading = false;
  }

  async save(item: RatingFormDto): Promise<void> {
    if (item.noShow) {
      this.confirmModalShow = true;
      this.form = item;
    } else {
      await this.saveInternal(item);
    }
  }

  onReject(): void {
    if (this.form != null){
      this.form.noShow = false;
    }

    this.form = null;
  }

  async confirm(): Promise<void> {
    if (this.form != null) {
      await this.saveInternal(this.form);
    }

    this.form = null;
  }

  async saveInternal(item: RatingFormDto): Promise<void> {
    if (!this.ratingData) {
      return;
    }

    this.loading = true;

    await this.$store.dispatch("Ratings/updateRating", {
      id: item.id,
      rating: item.rating,
      comments: item.comments,
      status: RatingStatus.Active.getId(this.ratingData.ratingStatuses),
      raterUserId: this.userInfo()?.sub,
      noShow: item.noShow,
      sickCall: item.sickCall
    });

    await this.$store.dispatch("Ratings/getRatingsByOffice", this.userInfo()?.practiceId);

    this.loading = false;
  }
}

export default RatingsComponent;
